export default {
  p: { x: 272, y: 255 },
  r: 30,
  s: [
    { x: 300, y: 400, b: 'ew', d: 100 },
    { x: 464, y: 350, b: 'ew', d: -200 },
    { x: 100, y: 450, b: 'ew', d: 100 },
  ],
  b: [
    { x: 260, y: 220 },
    { x: 460, y: 290 },
    { x: 460, y: 322 },
    { x: 460, y: 354 },
  ],
  g: [{ x: 600, y: 700 }],
  h: [
    { x: 200, y: 400 },
    { x: 478, y: 270 },
  ],
};
